<div fxLayout="column" fxLayoutAlign="start start" *ngIf="PartialViewReady">
    <h2>Contact Information</h2>
    <p>To facilitate the ease of maintaining communications, you may provide an updated or preferred phone number and email address that school counselors or college advisors can use to contact you regarding your Dual Enrollment requests. Please provide this optional information below:</p>
    <form [formGroup]="contactForm" novalidate fxLayout="column">
        <mat-form-field class="mat-block">
            <mat-icon matSuffix>call</mat-icon>
            <input type="text" matInput phone-input="parensdash" formControlName="ContactPhone" placeholder="Phone Number" maxlength="14" />
            <mat-error *ngIf="phone.hasError('phoneNumberValidator')">###-###-#### format</mat-error>
        </mat-form-field>
        <mat-form-field class="mat-block">
            <mat-icon matSuffix>email</mat-icon>
            <input type="text" matInput formControlName="ContactEmail" placeholder="Email Address" maxlength="50" />
            <mat-error *ngIf="email.hasError('pattern')">xxx@yyyy.zzzz format</mat-error>
        </mat-form-field>
        <div>
            <button type="submit" mat-raised-button color="primary" (click)="UpdateStudentContactInfo()" [disabled]="contactForm.invalid || (phone.value == LoadedPhone && email.value == LoadedEmail)">Update Info</button>
        </div>
    </form>
</div>


// WEBPACK FOOTER //
// ./src/app/studentcontact/studentcontact.component.html